export default {
  generalWeightLoss: {
    issues: [
      {
        id: 'I-ROS-4600',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  generalNightSweats: {
    issues: [
      {
        id: 'I-ROS-4500',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  generalFever: {
    issues: [
      {
        id: 'I-ROS-4400',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  generalInsomnia: {
    issues: [
      {
        id: 'I-ROS-4700',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  generalOther: {
    issues: [
      {
        id: 'I-ROS-4800',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  enteEpistaxis: {
    issues: [
      {
        id: 'I-ROS-1900',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  enteTinnitus: {
    issues: [
      {
        id: 'I-ROS-2000',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  enteDysphagia: {
    issues: [
      {
        id: 'I-ROS-2100',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  enteSmellChanges: {
    issues: [
      {
        id: 'I-ROS-2300',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  enteHearingChanges: {
    issues: [
      {
        id: 'I-ROS-2400',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  enteTasteChanges: {
    issues: [
      {
        id: 'I-ROS-2500',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  enteVisualChanges: {
    issues: [
      {
        id: 'I-ROS-2600',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  enteDoubleVision: {
    issues: [
      {
        id: 'I-ROS-2700',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  enteOther: {
    issues: [
      {
        id: 'I-ROS-2200',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  respiratoryCough: {
    issues: [
      {
        id: 'I-ROS-8800',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  respiratorySputum: {
    issues: [
      {
        id: 'I-ROS-8900',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  respiratoryDOE: {
    issues: [
      {
        id: 'I-ROS-9000',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  respiratoryOther: {
    issues: [
      {
        id: 'I-ROS-9100',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  cardiovascularChestPain: {
    issues: [
      {
        id: 'I-ROS-1300',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  cardiovascularPalpitations: {
    issues: [
      {
        id: 'I-ROS-1400',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  cardiovascularFaintness: {
    issues: [
      {
        id: 'I-ROS-1500',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  cardiovascularOther: {
    issues: [
      {
        id: 'I-ROS-1600',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  digestiveVomiting: {
    issues: [
      {
        id: 'I-ROS-2900',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  digestiveConstipation: {
    issues: [
      {
        id: 'I-ROS-3300',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  digestiveDiarrhea: {
    issues: [
      {
        id: 'I-ROS-3700',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  digestiveBrbpr: {
    issues: [
      {
        id: 'I-ROS-4100',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  digestiveReflux: {
    issues: [
      {
        id: 'I-ROS-4200',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  digestiveOther: {
    issues: [
      {
        id: 'I-ROS-4300',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  genitourinaryIncontinence: {
    issues: [
      {
        id: 'I-ROS-4900',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  genitourinaryDysuria: {
    issues: [
      {
        id: 'I-ROS-5000',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  genitourinaryHematuria: {
    issues: [
      {
        id: 'I-ROS-5100',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  genitourinaryOther: {
    issues: [
      {
        id: 'I-ROS-5200',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  musculoskeletalStiffness: {
    issues: [
      {
        id: 'I-ROS-6200',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  musculoskeletalJointSwelling: {
    issues: [
      {
        id: 'I-ROS-6300',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  musculoskeletalDecreasedRangeOfMotion: {
    issues: [
      {
        id: 'I-ROS-6400',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  musculoskeletalEdema: {
    issues: [
      {
        id: 'I-ROS-6500',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  musculoskeletalOther: {
    issues: [
      {
        id: 'I-ROS-6600',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  neurologicalHeadache: {
    issues: [
      {
        id: 'I-ROS-6700',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  neurologicalChangesInSpeech: {
    issues: [
      {
        id: 'I-ROS-6800',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  neurologicalSeizures: {
    issues: [
      {
        id: 'I-ROS-6900',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  neurologicalNumbness: {
    issues: [
      {
        id: 'I-ROS-7000',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  neurologicalWeakness: {
    issues: [
      {
        id: 'I-ROS-7100',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  neurologicalPoorBalance: {
    issues: [
      {
        id: 'I-ROS-7200',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  neurologicalTremors: {
    issues: [
      {
        id: 'I-ROS-7300',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  neurologicalOther: {
    issues: [
      {
        id: 'I-ROS-7400',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  integumentaryPruritus: {
    issues: [
      {
        id: 'I-ROS-5700',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  integumentaryRashes: {
    issues: [
      {
        id: 'I-ROS-5800',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  integumentaryLesions: {
    issues: [
      {
        id: 'I-ROS-5900',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  integumentaryIncisions: {
    issues: [
      {
        id: 'I-ROS-6000',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  integumentaryOther: {
    issues: [
      {
        id: 'I-ROS-6100',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  mentalhealthDifficultyConcentrating: {
    issues: [
      {
        id: 'I-ROS-7500',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  mentalhealthParanoia: {
    issues: [
      {
        id: 'I-ROS-7600',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  mentalhealthChangeInPersonality: {
    issues: [
      {
        id: 'I-ROS-7700',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  mentalhealthMania: {
    issues: [
      {
        id: 'I-ROS-7800',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  mentalhealthAgitation: {
    issues: [
      {
        id: 'I-ROS-7900',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  mentalhealthIrritability: {
    issues: [
      {
        id: 'I-ROS-8000',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  mentalhealthHopelessness: {
    issues: [
      {
        id: 'I-ROS-8100',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  mentalhealthSI: {
    issues: [
      {
        id: 'I-ROS-8200',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  mentalhealthHI: {
    issues: [
      {
        id: 'I-ROS-8300',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  mentalhealthLoneliness: {
    issues: [
      {
        id: 'I-ROS-8400',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  mentalhealthPoorBodyImage: {
    issues: [
      {
        id: 'I-ROS-8500',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  mentalhealthGrief: {
    issues: [
      {
        id: 'I-ROS-8600',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  mentalhealthOther: {
    issues: [
      {
        id: 'I-ROS-8700',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  endocrineTemperature: {
    issues: [
      {
        id: 'I-ROS-1700',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  endocrineOther: {
    issues: [
      {
        id: 'I-ROS-1800',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  hematologicPetechia: {
    issues: [
      {
        id: 'I-ROS-5300',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  hematologicExcessiveBleeding: {
    issues: [
      {
        id: 'I-ROS-5400',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  hematologicBruising: {
    issues: [
      {
        id: 'I-ROS-5500',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  hematologicOther: {
    issues: [
      {
        id: 'I-ROS-5600',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  allergiesAnaphylaxis: {
    issues: [
      {
        id: 'I-ROS-1000',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  },
  allergiesOther: {
    issues: [
      {
        id: 'I-ROS-1200',
        domain: 'DRS'
      }
    ],
    triggerValue: true
  }
}
